import React from 'react';
import { useStoreActions, useStoreState } from '../../../models/hooks';
import Pagination from '../../common/Pagination/Pagination';

export const TodoPagination = React.memo(function TodoPagination() {
  const { isLoading, isRefetching, paginatedTodos, currentPage, pageSize } = useStoreState((state) => state.todo);
  const { setCurrentPage, setPageSize } = useStoreActions((action) => action.todo);

  if (isLoading) return null;
  return (
    <Pagination
      currentPage={currentPage}
      total={paginatedTodos?.count ?? /* istanbul ignore next */ 0}
      onPageChange={setCurrentPage}
      onItemsPerPageChange={setPageSize}
      itemsPerPage={pageSize}
      isFetching={isLoading || isRefetching}
      storageKey="todoDashboard"
      size="large"
    />
  );
});
